import React from 'react';

import FieldText from '../common/FieldText';
import Const from '../../util/Constants';

class PropertyApiInfo extends React.Component {
  render() {
    const fields = this.props.model.fields;
    const property = this.props.property;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;
    return (
      <>
        { fields.property_code_99acres.visible === Const.True
          ? <div className="formhead col-md-12"><h2>API Configuration</h2></div>
          : null }
        <FieldText key="property_code_99acres" id="property_code_99acres" 
          field={fields.property_code_99acres} value={property.property_code_99acres}
          onValueChange={onValueChange} inValid={inValid} />
      </>
    );
  }
}

export default PropertyApiInfo;